import { render, staticRenderFns } from "./selectwork.vue?vue&type=template&id=4c56fc7a&"
import script from "./selectwork.vue?vue&type=script&lang=js&"
export * from "./selectwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports